import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CanAnyDirective, CanDirective, CannotDirective } from './can.directive';
import { PermissionService } from '../services/permission.service';


@NgModule({
  imports: [CommonModule],
  exports: [CanDirective],
  declarations: [CanDirective]
})
export class CanModule {
}

@NgModule({
  imports: [CommonModule],
  exports: [CannotDirective],
  providers: [PermissionService],
  declarations: [CannotDirective]
})
export class CannotModule {
}

@NgModule({
  imports: [CommonModule],
  exports: [CanAnyDirective],
  providers: [PermissionService],
  declarations: [CanAnyDirective]
})
export class CanAnyModule {
}



// WEBPACK FOOTER //
// ./src/app/pipes/can.module.ts